import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Maximize2 } from "lucide-react";
import Reveal from "./Reveal";

const PHOTOS = [
    {
        id: 1,
        src: "https://customer-assets-v7afamib.emergentagent.net/job_engulf-seminar-kl/artifacts/3e2397a3cd5d9ece_photo_2026-10-14_12-36-51.jpg",
        alt: "Peserta seminar Queen of Dollars beramai-ramai di hadapan skrin sesi Start Your Forex Journey",
        span: "md:col-span-7",
        h: "h-[260px] md:h-[460px]",
    },
    {
        id: 2,
        src: "https://customer-assets-v7afamib.emergentagent.net/job_engulf-seminar-kl/artifacts/3c034a1ddee33fd5_photo_2026-10-14_12-36-51%20%282%29.jpg",
        alt: "Gambar kumpulan peserta selepas sesi seminar trading bersama penganjur",
        span: "md:col-span-5",
        h: "h-[300px] md:h-[460px]",
    },
];

const Gallery = () => {
    const [open, setOpen] = useState(null);

    useEffect(() => {
        document.body.style.overflow = open !== null ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && setOpen(null);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    return (
        <section data-testid="gallery-section" className="relative py-24 md:py-32">
            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-flame">
                        Galeri seminar lepas
                    </p>
                    <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-6xl">
                        THIS IS WHAT YOU'VE BEEN MISSING! 🔥
                    </h2>
                    <p className="mt-5 max-w-2xl leading-relaxed text-white/65">
                        Jom tengok antara moment daripada seminar yang pernah
                        kami adakan sebelum ni!
                    </p>
                </Reveal>

                <div className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 md:grid md:grid-cols-12 md:overflow-visible">
                    {PHOTOS.map((p, i) => (
                        <Reveal
                            key={p.id}
                            delay={0.08 * i}
                            className={`min-w-[84vw] snap-center sm:min-w-[64vw] md:min-w-0 ${p.span}`}
                        >
                            <button
                                type="button"
                                onClick={() => setOpen(i)}
                                data-testid={`gallery-item-${i + 1}`}
                                className={`group relative block w-full overflow-hidden rounded-3xl border border-white/10 ${p.h}`}
                            >
                                <img
                                    src={p.src}
                                    alt={p.alt}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                                <span className="absolute bottom-4 left-4 flex items-center gap-2 rounded-full bg-black/70 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.22em] text-white/90 backdrop-blur">
                                    <Maximize2 size={12} className="text-flame" />
                                    Moment sebenar — {String(i + 1).padStart(2, "0")}
                                </span>
                            </button>
                        </Reveal>
                    ))}
                </div>
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35 md:hidden">
                    Swipe untuk lihat →
                </p>
            </div>

            <AnimatePresence>
                {open !== null && (
                    <motion.div
                        data-testid="gallery-lightbox"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setOpen(null)}
                        className="fixed inset-0 z-[70] flex items-center justify-center bg-black/90 p-4 backdrop-blur-xl"
                    >
                        <motion.div
                            initial={{ scale: 0.92, y: 24 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.95, opacity: 0 }}
                            transition={{ type: "spring", stiffness: 300, damping: 26 }}
                            onClick={(e) => e.stopPropagation()}
                            className="relative w-full max-w-4xl"
                        >
                            <button
                                type="button"
                                onClick={() => setOpen(null)}
                                data-testid="lightbox-close-button"
                                aria-label="Tutup"
                                className="absolute -top-12 right-0 rounded-full border border-white/20 p-2 text-white/80 transition-colors duration-300 hover:border-flame hover:text-flame"
                            >
                                <X size={20} />
                            </button>
                            <img
                                src={PHOTOS[open].src}
                                alt={PHOTOS[open].alt}
                                data-testid={`lightbox-image-${open + 1}`}
                                className="max-h-[78vh] w-full rounded-3xl border border-white/15 object-contain"
                            />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
};

export default Gallery;
